module.exports = __webpack_public_path__ + "static/media/Logo.1f6f2ff7.png";